import { useState, useEffect } from 'react';
import Select from 'react-select';


function Links(){
    const [amount, setAmount] = useState('');
    const [email, setEmail] = useState('');
    const [links, setLinks] = useState([]);
    const [songs, setSongs] = useState([]);
    const [pickedSongs, setPickedSongs] = useState([]);

    useEffect(() => {
        if(!email){
          setSongs([]);
          return;
        } else {
          const timeout = setTimeout(async () => {
            try{
          const res = await fetch(`/links?email=${encodeURIComponent(email)}`);
          const data = await res.json();
          setSongs(data.song); 
          console.log('songs set');
          console.log(data.song);
          } catch(err){console.error(err);}
            }, 10000);
              return () => clearTimeout(timeout);
        }
  }, [email]);

   /*const pickSongs = (e) => {
      const group = Array.from(e.target.options)
      const ss = group.filter((song) => song.selected).map((song) => song.value);
      setPickedSongs(ss);
      console.log(pickedSongs);
      console.log(songs);
    } */
   const pickSongs = (selected) => {
    setPickedSongs(selected);
   }

    async function getLinks(){
        // frontend to display list of links after button click
        try{
            const res = await fetch(`/links?amount=${encodeURIComponent(amount)}&email=${encodeURIComponent(email)}`);
             if(!res.ok) throw new Error('Links didnt work'); else {
                // get links
            const data = await res.json();
                setLinks(data.endpoint);
                console.log(links);
            }
        } catch(err) {console.error(err);}
    }

    return (
        <div>
          <div>
          <p>Pick songs for your juug:</p>
          <Select isMulti options={songs.map(song => ({value: song, label: song}))} value={pickedSongs} onChange={pickSongs}/>
          <select multiple={true} value={songs}>
        {
          songs.length > 0 ? (
          songs.map((value, index) => (
          <option key={index} value={value}>{value}</option>
          ))):<></>
        }      
          </select>
        </div>
            <form id='downloadForm' onSubmit={(e) => {e.preventDefault(); getLinks()}}>
            <p>amount</p><input type='text' onChange={e => setAmount(e.target.value)}></input>
            <p>email </p><input type='text' onChange={e => {e.preventDefault(); setEmail(e.target.value)}}></input>
            <button type='submit'>Links</button>
            </form>

        <ol>
          {links.length > 0 ? (
            Object.entries(links).map(([k, v]) => (
              <a href={`/music/${v}`} target="_blank" rel="noopener noreferrer">
              <li key={k}>mp3juug.com/music/{v}</li></a>
            ))
          ) : (
            <p>No links yet</p>
          )}
        </ol>
        </div>
    )
}



export default Links;